import LanguageContext from "components/LanguageContext";
import SiteContext from "components/SiteContext";
import useGetBanners from "hooks/banner.hook";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { localeDateNow } from "utils/bannersUtils";
import t from "utils/locales/translation.json";

const Banner = () => {
  const { language } = useContext(LanguageContext);
  const site = useContext(SiteContext);
  const { id: siteId } = site || {};

  const [hiddenBanners, setHiddenBanners] = useState(null);
  const [hasRetrievedHiddenBanners, setHasRetrievedHiddenBanners] = useState(false);

  const { data: banners } = useGetBanners(siteId);

  useEffect(() => {
    if (typeof localStorage !== "undefined") {
      setHiddenBanners(localStorage.getItem("hiddenBanner"));
      setHasRetrievedHiddenBanners(true);
    }
  }, []);

  const hiddenBannerArray = useMemo(() => hiddenBanners?.split(",") || [], [hiddenBanners]);

  const handleHideBanner = useCallback(
    (id) => {
      if (!hiddenBannerArray.includes(id)) {
        setHiddenBanners(hiddenBanners ? hiddenBanners.concat(",", id) : id);
      }
    },
    [hiddenBanners, hiddenBannerArray],
  );

  if (hiddenBanners && typeof localStorage !== "undefined") {
    localStorage.setItem("hiddenBanner", hiddenBanners);
  }

  if (!hasRetrievedHiddenBanners || !Array.isArray(banners)) {
    return null;
  }

  const externalLinkProps = (content) => {
    const { externalLink, linkLabel } = content || {};
    if (externalLink) {
      return {
        target: "_blank",
        rel: "noopener noreferrer",
        title: `${linkLabel} - ${t[language].components.new_tab}`,
      };
    }
    return {};
  };

  return banners?.map((banner) => {
    const { id, type, contents, forceDisplay, displayStartDate, displayEndDate, externalLink } = banner || {};
    const isDisplayed =
      forceDisplay || (Date.parse(displayStartDate) <= localeDateNow && Date.parse(displayEndDate) >= localeDateNow);
    if (hiddenBannerArray?.includes(id) || !isDisplayed) {
      return null;
    }
    const { title, text, link, linkLabel } = contents?.find((content) => content.lang === language) || {};
    return (
      <div className={`fr-notice fr-notice--${type}`} key={id}>
        <div className="fr-container">
          <div className="fr-notice__body">
            <p>
              <span className="fr-notice__title">{title}</span>
              {text && <span className="fr-notice__desc">{text}</span>}
              {linkLabel && (
                <a href={link} className="fr-notice__link" {...externalLinkProps({ externalLink, linkLabel })}>
                  {linkLabel}
                </a>
              )}
            </p>
            <button
              type="button"
              title="Masquer le message"
              onClick={() => handleHideBanner(id)}
              id="hide-button"
              className="fr-btn--close fr-btn"
            >
              Masquer le message
            </button>
          </div>
        </div>
      </div>
    );
  });
};

export default Banner;
